/* eslint-disable import/prefer-default-export */
import useSWR from 'swr';
import { fetcher } from '@/utils/queries';

const useSyncOutlook = (clientId: number) => {
  const data = useSWR(`/api/calendar/syncCalendarEvents/${clientId}`, fetcher, {
    revalidateOnMount: false,
    revalidateOnFocus: false,
  });
  return data;
};

export { useSyncOutlook };
